import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "text-success fw-bold" }
const _hoisted_3 = {
  class: "col-12 position-relative",
  style: {"height":"450px"}
}
const _hoisted_4 = ["href"]

import PersonalTable from "@/components/PersonalTable.vue";
    import Api from "@/services/api";
    import { Product, User } from "@/services/types";
    import { ElMessage, ElMessageBox } from "element-plus";
    import { computed, onBeforeMount, reactive, ref } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip, } from "@vue-leaflet/vue-leaflet"
    import { Order } from "@/services/types/order";
import ProductsList from "@/components/ProductsList.vue";
import { url } from "node:inspector";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RequestView',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()
    const {id} = route.params

    const loading = ref<boolean>(true)
    const updating = ref<boolean>(false)
        
        const status = reactive<{
        'pendente': string
        'andamento': string
        'entregue': string
        'preparo': string
    }>({
        'pendente': 'danger',
        'andamento': 'warning',
        'preparo': 'primary',
        'entregue': 'success'
    })
    
    const order = ref<Order>()
    const sellers = ref<Array<User>>([])
    const products = computed(() => order.value?.store_orders.flatMap(o => o.items) ?? [])
    
    const getOrder = async () => {
        updating.value = true
        const res = await Api.get('admin/orders/' + id)
        if (res.status == 200) {
            const data = res.data.order
            order.value = data
        } else if (res.status != 404) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message, {type: "error"}).then(() => router.push('/products')).catch(() => router.push('/products'))
        }
        updating.value = false
    }

    onBeforeMount(async () => {
        loading.value = true
        // get sellers
        const res = await Api.get('admin/sellers')
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ao buscar os entregadores ' + res.data.message})
            return
        }
        sellers.value = res.data.sellers
        await getOrder()

        loading.value = false
    })

    const submit = async () => {
            updating.value = true
            const res = await Api.put(`admin/orders/${id}?delivery_id=${order.value?.delivery_id}`, {})
            console.log(res.data)

            if (res.status == 200) {
                ElMessage.success({message: 'Entregador Actualizado com sucesso'})
                // location.reload()
                await getOrder()
            } else if (res.status == 422) {
                if (res.data.errors) {
                    for(let err in res.data.errors) {
                        ElMessage.error({message: res.data.errors[err].join(', ')})
                    }
                }
            } else {
                ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
            }
            updating.value = false
           
    }

    const cancel = async () => {
        if (confirm("Deseja realmente cancelar este pedido?\n\nEsta acção é irreversível")) {
            updating.value = true
            const res = await Api.delete(`admin/orders/${id}`)
            if (res.status == 200) {
                ElMessageBox.alert("Pedido cancelado e eliminado").then(() => {
                    router.replace('/dashboard')
                })
            } else {
                ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
            }
            updating.value = true

        }
    }

    const openProduct = (id: number | string) => {
        router.push('/products/' + id)
    }

return (_ctx: any,_cache: any) => {
  const _component_el_result = _resolveComponent("el-result")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Phone = _resolveComponent("Phone")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElRow = _resolveComponent("ElRow")!
  const _component_ElCol = _resolveComponent("ElCol")!
  const _component_MapLocation = _resolveComponent("MapLocation")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Detalhes do pedido" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_skeleton, {
          loading: loading.value,
          animated: "",
          rows: 12
        }, {
          default: _withCtx(() => [
            (!order.value)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  justify: "center",
                  align: "middle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      sm: 12,
                      lg: 7
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_result, {
                          icon: "error",
                          title: "Pedido não encontrado",
                          "sub-title": "O Pedido que procura não foi encontrado, por favor verifique se consta da lista"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_form, {
                    disabled: updating.value,
                    model: order.value,
                    "label-position": "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            sm: 24,
                            md: 14,
                            lg: 16
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_row, { gutter: 20 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    sm: 24,
                                    md: 12,
                                    lg: 8
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        label: "Cliente",
                                        class: "form-control"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { class: "mx-1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_UserFilled)
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" " + _toDisplayString(order.value.user.name), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    sm: 24,
                                    md: 12,
                                    lg: 8
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        label: "Atribuido a",
                                        prop: "seller_id",
                                        class: "form-control"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            disabled: order.value.status == 'entregue',
                                            modelValue: order.value.delivery_id,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((order.value.delivery_id) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sellers.value, (s) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  label: s.name,
                                                  value: s.id,
                                                  key: s.id
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_row, { gutter: 10 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_el_col, { md: 12 }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_el_icon, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_UserFilled)
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(s.name) + " ", 1),
                                                            _createVNode(_component_el_icon, { class: "ms-2" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_Phone)
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(s.phone), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["disabled", "modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    sm: 24,
                                    md: 12,
                                    lg: 8
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        label: "Estado do pedido",
                                        class: _normalizeClass(`form-control border-${status[order.value.status]}`)
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(`col-auto p-0 px-2 rounded text-light fw-bold bg-${status[order.value.status]} bg-gradient`)
                                          }, _toDisplayString(order.value.status), 3)
                                        ]),
                                        _: 1
                                      }, 8, ["class"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    sm: 24,
                                    md: 12,
                                    lg: 8
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        label: "Solicitado em",
                                        class: "form-control"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(new Date(order.value.created_at ?? '').toLocaleString()), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    sm: 24,
                                    md: 12,
                                    lg: 8
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        label: "Contacto cliente",
                                        class: "form-control"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { class: "mx-1" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Phone)
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" " + _toDisplayString(order.value.phone), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (order.value.status != 'pendente')
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 0,
                                        sm: 24,
                                        md: 12,
                                        lg: 8
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_form_item, {
                                            label: "Atualizado em",
                                            class: "form-control"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(new Date(order.value.updated_at ?? '').toLocaleString()), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_col, {
                                    sm: 24,
                                    md: 12,
                                    lg: 8
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        label: "Total geral:",
                                        class: "form-control"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("label", _hoisted_2, _toDisplayString(order.value.total_price.toFixed(2).replace('.', ',')) + " MT ", 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_col, {
                                    sm: 24,
                                    md: 12,
                                    lg: 8
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        label: "",
                                        class: ""
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  (['pendente'].includes(order.value.status))
                                    ? (_openBlock(), _createBlock(_component_ElCol, {
                                        key: 1,
                                        cols: 24,
                                        class: "px-4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ElRow, { gutter: 20 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_form_item, { label: "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_button, {
                                                    loading: updating.value,
                                                    onClick: submit,
                                                    plain: "",
                                                    type: "warning"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                      _createTextVNode(" Alterar entregador ", -1)
                                                    ]))]),
                                                    _: 1
                                                  }, 8, ["loading"])
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_el_form_item, {
                                                label: "",
                                                class: "mx-2"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_button, {
                                                    loading: updating.value,
                                                    onClick: cancel,
                                                    plain: "",
                                                    type: "danger"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                      _createTextVNode(" Canelar pedido ", -1)
                                                    ]))]),
                                                    _: 1
                                                  }, 8, ["loading"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            sm: 24,
                            md: 10,
                            lg: 8
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, null, {
                                label: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_MapLocation)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(order.value.area?.name), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_unref(LMap), {
                                      ref: "map",
                                      zoom: 16,
                                      center: [order.value.area?.lat ?? 0, order.value.area?.long ?? 0]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LTileLayer), {
                                          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                                          "layer-type": "base",
                                          name: "OpenStreetMap"
                                        }),
                                        _createVNode(_unref(LMarker), {
                                          "lat-lng": [order.value.area?.lat ?? 0, order.value.area?.long ?? 0],
                                          draggable: false
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(LTooltip), null, {
                                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                                _createTextVNode("Local da entrega", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["lat-lng"])
                                      ]),
                                      _: 1
                                    }, 8, ["center"]),
                                    _createElementVNode("a", {
                                      target: "_blank",
                                      href: `https:\/\/www.google.com/\maps?q=${order.value.area?.lat},${order.value.area?.long}`,
                                      class: "btn btn-warning"
                                    }, "Abrir no google maps", 8, _hoisted_4)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled", "model"]),
                  _createVNode(_component_el_col, { sm: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_collapse, {
                        accordion: "",
                        class: "my-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_collapse_item, {
                            name: "1",
                            title: "Produtos do pedido"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.store_orders, (storeOrder) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: storeOrder.store_id
                                }, [
                                  _createElementVNode("h6", null, [
                                    _cache[4] || (_cache[4] = _createTextVNode("Da loja ", -1)),
                                    _createVNode(_component_RouterLink, {
                                      to: `/admin/store/${storeOrder.store.id}`
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(storeOrder.store.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]),
                                  _createVNode(ProductsList, {
                                    onClickOpen: openProduct,
                                    items: storeOrder.items.map(item => ({
                                            icon: 'View', 
                                            id: Number(item.product.id), 
                                            image: '', 
                                            title: item.product.name,
                                            subtitle: `${item.quant} unidades x ${item.unit_price.toFixed(2).replace('.', ',')}MT \n = ${(item.quant * item.unit_price).toFixed(2).replace('.', ',')} MT`
                                        }))
                                  }, null, 8, ["items"])
                                ], 64))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}
}

})